import { z } from "zod";
import { PayStandAddressSchema } from "./pay-stand-address";

export const PayStandBankSchema = z.object({
  id: z.string(),
  object: z.string(),
  bankName: z.string(),
  accountType: z.enum(["checking", "savings"]),
  accountHolderType: z.enum(["individual", "company"]),
  nameOnAccount: z.string(),
  routingNumber: z.string(),
  last4: z.string(),
  payerId: z.string(),
  billingAddress: PayStandAddressSchema,
  status: z.string(),
  created: z.string(),
  lastUpdated: z.string(),
});

export type PayStandBankType = z.infer<typeof PayStandBankSchema>;
